// Alerts

export const canSeeAlerts = (userRole = {}) => {
  return !!userRole?.['alert:read'];
};

// Blueprints (Solutions)

export const canCreateBlueprints = (userRole) => {
  return !!userRole?.['blueprint:create'];
};

export const canSeeBlueprints = (userRole) => {
  return !!userRole?.['blueprint:read'];
};

export const canUpdateBlueprints = (userRole) => {
  return !!userRole?.['blueprint:update'];
};

export const canDeleteBlueprints = (userRole) => {
  return !!userRole?.['blueprint:delete'];
};

// Device models

export const canCreateDeviceModel = (userRole) => {
  return !!userRole?.['deviceModel:create'];
};

export const canUpdateDeviceModel = (userRole) => {
  return !!userRole?.['deviceModel:update'];
};

// Equipment

export const canCreateEquipment = (userRole) => {
  return !!userRole?.['equipment:create'];
};

export const canReadEquipment = (userRole) => {
  return !!userRole?.['equipment:read'];
};

export const canUpdateEquipment = (userRole) => {
  return !!userRole?.['equipment:update'];
};

export const canDeleteEquipment = (userRole) => {
  return !!userRole?.['equipment:delete'];
};

// Fleets

export const canCreateFleet = (userRole) => {
  return !!userRole?.['fleet:create'];
};

export const canSeeFleets = (userRole) => {
  return !!userRole?.['fleet:read'];
};

export const canUpdateFleet = (userRole) => {
  return !!userRole?.['fleet:update'];
};

// Greener eyes

export const canCreateEye = (userRole) => {
  return !!userRole?.['greenerEye:create'];
};

export const canUpdateEye = (userRole) => {
  return !!userRole?.['greenerEye:update'];
};

// Greener units

export const canCreateAsset = (userRole) => {
  return !!userRole?.['greenerUnit:create'];
};

export const canReadAsset = (userRole) => {
  return !!userRole?.['greenerUnit:read'];
};

export const canUpdateAsset = (userRole) => {
  return !!userRole?.['greenerUnit:update'];
};

// Greener units - operator chat

export const canSeeOperatorChat = (userRole) => {
  return !!userRole?.['greenerUnit:chat'];
};

// Microgrids

export const canCreateMicrogrid = (userRole) => {
  return !!userRole?.['microgrid:create'];
};

export const canSeeMicrogrid = (userRole) => {
  return !!userRole?.['microgrid:read'];
};

export const canUpdateMicrogrid = (userRole) => {
  return !!userRole?.['microgrid:update'];
};

export const canDeleteMicrogrid = (userRole) => {
  return !!userRole?.['microgrid:delete'];
};

// Organisations

export const canCreateOrganisation = (userRole) => {
  return !!userRole?.['organisation:create'];
};

export const canUpdateOrganisation = (userRole) => {
  return !!userRole?.['organisation:update'];
};

export const canDeleteOrganisations = (userRole) => {
  return !!userRole['organisation:delete'];
};

// Organisations - alert email recipients

export const canCreateAlertEmailRecipients = (userRole) => {
  return !!userRole['organisationAlertEmailRecipient:create'];
};

export const canSeeAlertEmailRecipients = (userRole) => {
  return !!userRole['organisationAlertEmailRecipient:read'];
};

export const canDeleteAlertEmailRecipients = (userRole) => {
  return !!userRole['organisationAlertEmailRecipient:delete'];
};

// Organisations - alert robocall recipients

export const canCreateAlertRobocallRecipients = (userRole) => {
  return !!userRole?.['organisationAlertRobocallRecipient:create'];
};

export const canDeleteAlertRobocallRecipients = (userRole) => {
  return !!userRole?.['organisationAlertRobocallRecipient:delete'];
};

// PGUIs

export const canCreatePgui = (userRole) => {
  return !!userRole?.['pgui:create'];
};

export const canSeePguis = (userRole) => {
  return !!userRole?.['pgui:read'];
};

export const canUpdatePgui = (userRole) => {
  return !!userRole?.['pgui:update'];
};

export const canDeletePgui = (userRole) => {
  return !!userRole?.['pgui:delete'];
};

// Projects

export const canCreateProjects = (userRole) => {
  return !!userRole?.['project:create'];
};

export const canEditProjects = (userRole) => {
  return !!userRole?.['project:update'];
};

export const canDeleteProjects = (userRole) => {
  return !!userRole?.['project:delete'];
};

// Project organisations

export const canCreateProjectOrganisations = (userRole) => {
  return !!userRole?.['projectOrganisation:create'];
};

export const canDeleteProjectOrganisations = (userRole) => {
  return !!userRole?.['projectOrganisation:delete'];
};

// Reports

export const canCreateReports = (userRole) => {
  return !!userRole?.['report:create'];
};

export const canSeeReports = (userRole) => {
  return !!userRole?.['report:read'];
};

export const canDeleteReports = (userRole) => {
  return !!userRole?.['report:delete'];
};

// Users

export const canCreateUser = (userRole) => {
  return !!userRole?.['user:create'];
};

export const canUpdateUser = (userRole) => {
  return !!userRole?.['user:update'];
};

export const canDeleteUser = (userRole) => {
  return !!userRole?.['user:delete'];
};

// User roles

export const canCreateUserRoles = (userRole) => {
  return !!userRole?.['user:create']; // TODO refactor when permission user_role:create will be added
};

// Watcher types

export const canCreateWatcherType = (userRole) => {
  return !!userRole?.['watcherType:create'];
};

export const canUpdateWatcherType = (userRole) => {
  return !!userRole?.['watcherType:update'];
};

// Watch (HMI proxy)

export const canInterrogateWatch = (userRole) => {
  return !!userRole?.['watch:interrogate'];
};

export const canOperateWatch = (userRole) => {
  return !!userRole?.['watch:operate'];
};

export const canAdministrateWatch = (userRole) => {
  return !!userRole?.['watch:administrate'];
};

//Flag of internal features in the absence of a user role

export const isGreenerEmployee = (user) => user?.organisation?.externalIdentifier === 'greener';
